import { State } from '.';
import { DosageFormType } from '../../models/dosage-form-type';

export const selectors = {
    getDosageFormType: (
        state: State,
        id: Undefinable<string>
    ): Undefinable<DosageFormType> => state.byId[id || ''],
    getDosageFormTypeIds: (
        state: State
    ): string[] => state.allIds,
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false
};
